<template>
    <div class="platform">
        <div class="platform_left">
            <span>平台权益</span>
        </div>
        <div class="platform_right">
            <van-grid direction="horizontal" gutter='1px' :column-num="3">
                <van-grid-item v-for="(item, index) in platData" :key="index + '001'" @click="handleJump(item.link)" :icon="item.pictureUrl" :text="item.name" />
            </van-grid>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    props: {
        platData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    methods: {
        handleJump (jumpUrl) {
            if (!jumpUrl) {
                Toast('敬请期待！')
                return false
            }
            this.$router.push({ path: jumpUrl })
        }
    }
}
</script>

<style lang="scss" scoped>
.platform {
    display: flex;
    justify-content: start;
    padding: 18px 24px;
    font-size: 28px;
    color: #333333;
    &_left {
        padding: 0 32px;
        display: flex;
        align-items: center; /* 垂直居中 */
        background: linear-gradient(90deg, #ccaa74 0%, #e7cea9 100%);
        border-radius: 16px 0 0 16px;
        span {
            display: inline-block;
            width: 28px;
        }
    }
    &_right {
        flex: 1;
        font-size: 24px;
    }
}
/deep/ .van-grid {
    padding-left: 0 !important;
}
/deep/ .van-grid-item__content--center {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
    padding: 30px 0;
    background: #635f5e;
}
/deep/ .van-grid-item__icon {
    font-size: 40px;
}
/deep/ .van-grid-item__text {
    color: #fff1d6;
    margin-top: 0;
    margin-left: 16px;
    font-size: 24px;
}
/deep/ .van-grid-item:nth-child(3) {
    /deep/ .van-grid-item__content--center {
        border-top-right-radius: 16px;
    }
}
/deep/ .van-grid-item:nth-child(6) {
    /deep/ .van-grid-item__content--center {
        border-bottom-right-radius: 16px;
    }
}
</style>